module.exports = __webpack_public_path__ + "img/figure-2.1.7482bce7.png";